import type { ReactNode } from "react";
import { CaseMeterRow } from "./CaseMeterRow.js";
import { CaseSurvivalRow } from "./CaseSurvivalRow.js";
import { DeadlinePips } from "./DeadlinePips.js";
import type { StatHelpTopic } from "./statHelp.js";
import type { CardId } from "../../domain/types/index.js";
import { InvestmentTags } from "./InvestmentTags.js";

type CaseFoePanelProps = {
  name: string;
  progress: number;
  pendingProgress?: number;
  required: number;
  progressValue: ReactNode;
  deadline: number;
  fatigue: number;
  fatigueMax?: number;
  block: number;
  fatigueValue?: ReactNode;
  blockValue?: ReactNode;
  deadlineChanging?: boolean;
  progressFrom?: number;
  progressGain?: number;
  fatigueFrom?: number;
  investments?: readonly CardId[];
  onHelp: (topic: StatHelpTopic) => void;
};

export function CaseFoePanel({
  name,
  progress,
  pendingProgress = 0,
  required,
  progressValue,
  deadline,
  fatigue,
  fatigueMax,
  block,
  fatigueValue = <b>{fatigue}</b>,
  blockValue = <b>{block}</b>,
  deadlineChanging,
  progressFrom,
  progressGain,
  fatigueFrom,
  investments,
  onHelp,
}: CaseFoePanelProps) {
  return (
    <section className="foe" aria-labelledby="case-foe-name">
      <div className="foe-title-row">
        <h2 id="case-foe-name" className="foe-name">{name}</h2>
        <InvestmentTags cardIds={investments} />
      </div>
      <CaseMeterRow
        label="進捗"
        icon="progress"
        topic="progress"
        value={<>{progressValue}{pendingProgress > 0 ? <span className="pending-progress">保留 +{pendingProgress}</span> : null}</>}
        max={required}
        barValue={progress}
        from={progressFrom}
        glitterGain={progressGain}
        onHelp={onHelp}
      />
      <DeadlinePips remaining={deadline} changing={deadlineChanging} onHelp={onHelp} />
      <CaseSurvivalRow
        fatigue={fatigue}
        fatigueMax={fatigueMax}
        fatigueValue={fatigueValue}
        blockValue={blockValue}
        from={fatigueFrom}
        onHelp={onHelp}
      />
    </section>
  );
}
